import React from "react";
import "../styles/screen.css";

const ScreenResult = ({ input }) => (
  <div
    className="input"
    id="input"
  >
    {input}
  </div>
);

export default ScreenResult;